export const DELETE_POOL_REQUESTS_FAILURE = 'DELETE_POOL_REQUESTS_FAILURE';

export const deletePoolRequestsFailure = error => ({
    type: DELETE_POOL_REQUESTS_FAILURE,
    payload: error,
    error: true,
});
